"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vallio-terme": {
    "09e976c5": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "skipSearch": false
    }],
    "bernacco": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c09b6c99": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "skipSearch": false
    }],
    "caschino": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f91bf84": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ef0df1ea": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "skipSearch": false
    }],
    "gazzino": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "75af74bd": [{
      "hkey": "a7bee0a1",
      "slug": "porle-sconzane",
      "name": "Porle-Sconzane",
      "primary": true,
      "skipSearch": false
    }],
    "porle": [{
      "hkey": "a7bee0a1",
      "slug": "porle-sconzane",
      "name": "Porle-Sconzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9f9d6c47": [{
      "hkey": "a7bee0a1",
      "slug": "porle-sconzane",
      "name": "Porle-Sconzane",
      "primary": true,
      "skipSearch": false
    }],
    "sconzane": [{
      "hkey": "a7bee0a1",
      "slug": "porle-sconzane",
      "name": "Porle-Sconzane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vallio-terme"
    }],
    "9792a06a": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "skipSearch": false
    }],
    "somagro": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2222b86a": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "skipSearch": false
    }],
    "sopranico": [{
      "hkey": "a13ed35c",
      "slug": "vallio-terme",
      "name": "Vallio Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;